/* Repeated calls to action use the native product form, including availability,
   quantity, validation, optional extras and the existing cart drawer. */
(() => {
  if (window.sbdScrollPurchaseBound) return;
  window.sbdScrollPurchaseBound = true;
  const nativeBuy = () => document.querySelector(':is(.sbd-hero-panel, .rd-purchase) .buy-buttons-block add-to-cart-component .button');
  const sync = () => {
    const source = nativeBuy();
    document.querySelectorAll('[data-scroll-buy]').forEach(button => {
      const unavailable = !source || source.disabled || source.getAttribute('aria-disabled') === 'true';
      button.disabled = unavailable;
      button.querySelector('[data-scroll-buy-label]').textContent = unavailable ? 'Unavailable' : 'Add to cart';
    });
  };
  document.addEventListener('click', event => {
    const jump = event.target.closest('.sbd-detail-jumps a[href^="#"]');
    if (jump) {
      const section = document.getElementById(jump.hash.slice(1));
      if (section) {
        event.preventDefault();
        section.scrollIntoView({ behavior: 'instant', block: 'start' });
        section.setAttribute('tabindex', '-1');
        section.focus({ preventScroll: true });
        history.replaceState(null, '', jump.hash);
      }
      return;
    }
    const action = event.target.closest('[data-scroll-buy], [data-scroll-customize]');
    if (!action || action.disabled) return;
    const source = action.matches('[data-scroll-buy]') ? nativeBuy() : document.querySelector(':is(.sbd-hero-panel, .rd-purchase) [data-sbd-customize-her]');
    if (!source || source.disabled) { sync(); return; }
    source.click();
    // Reveal native validation if it prevented the add operation.
    const error = document.querySelector(':is(.sbd-hero-panel, .rd-purchase) [ref="addToCartTextError"]');
    if (error && !error.classList.contains('hidden') && error.textContent.trim()) {
      error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
  const init = () => {
    sync();
    if ('IntersectionObserver' in window) {
      const mediaObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
      });
      document.querySelectorAll('.sbd-proof video').forEach(video => mediaObserver.observe(video));
    }
    const panel = document.querySelector(':is(.sbd-hero-panel, .rd-purchase)');
    if (panel) new MutationObserver(sync).observe(panel, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
